/* eslint-disable  */

// ** React Imports
/* eslint-disable  */
import { lazy } from "react";
import { Navigate } from "react-router-dom";

const Welcome = lazy(() => import("../../views/apps/welcome"));
const InvoiceCreate = lazy(() => import("../../views/apps/invoiceCreate"));

const InvoicePrint = lazy(() =>
  import("../../views/apps/order/components/invoice/print")
);

const UserList = lazy(() => import("../../views/apps/user/list"));
const AgentPageList = lazy(() => import("../../views/apps/user/agentPage"));
const DriverList = lazy(() => import("../../views/apps/user/drivers"));
const ReferralUserList = lazy(() =>
  import("../../views/apps/user/referralUser")
);
const RecruiterUserList = lazy(() =>
  import("../../views/apps/user/recruiterUser")
);

const AgentAssistantList = lazy(() =>
  import("../../views/apps/user/agentAssistant/list")
);

const DeletedUserList = lazy(() => import("../../views/apps/user/deletedUser"));
const InActiveAgentList = lazy(() =>
  import("../../views/apps/user/inActiveAgent")
);

const LabelsList = lazy(() => import("../../views/apps/labels/list"));
const TaxList = lazy(() => import("../../views/apps/tax/list"));

const RankingAgentList = lazy(() =>
  import("../../views/apps/rankingAgent/list")
);
const RankingManagerList = lazy(() =>
  import("../../views/apps/rankingManager/list")
);

const RankingAssistantList = lazy(() =>
  import("../../views/apps/rankingAssistant/list")
);

const RefundList = lazy(() => import("../../views/apps/refund/list"));
const SumUpList = lazy(() => import("../../views/apps/sumUp/list"));
const SumUpForAllList = lazy(() =>
  import("../../views/apps/sumUp/sumUpForAll")
);
const DepotList = lazy(() => import("../../views/apps/depot/list"));
const StateList = lazy(() => import("../../views/apps/state/list"));

const SaleManagerManagementList = lazy(() =>
  import("../../views/apps/saleManagerManagement/list")
);

const ReferralBounceList = lazy(() =>
  import("../../views/apps/referralBounce/list")
);
const ReferralBounceAdmin = lazy(() =>
  import("../../views/apps/referralBounce/admin")
);
const ReferralBounceCheck = lazy(() =>
  import("../../views/apps/referralBounce/check")
);

const OrderList = lazy(() => import("../../views/apps/order/list"));
const OrderSeasonalList = lazy(() =>
  import("../../views/apps/order/seasonalDeposit")
);
const SalesPiplineList = lazy(() =>
  import("../../views/apps/order/salesPipline")
);
const OrderView = lazy(() => import("../../views/apps/order/view"));
const OrderInvoice = lazy(() =>
  import("../../views/apps/order/components/invoice")
);
const OrderPaymentDebit = lazy(() =>
  import("../../views/apps/order/components/paymentDebit")
);
const OrderPaymentECheck = lazy(() =>
  import("../../views/apps/order/components/paymentECheck")
);
const ContainerList = lazy(() => import("../../views/apps/container/list"));

const Containers = lazy(() => import("../../views/apps/container/containers"));

const DiscountOwnerList = lazy(() =>
  import("../../views/apps/discount/ownerDiscount")
);
const DiscountCustomList = lazy(() =>
  import("../../views/apps/discount/customDiscount")
);
const DiscountAgentList = lazy(() =>
  import("../../views/apps/discount/agentDiscount")
);

const VendorList = lazy(() => import("../../views/apps/vendor/list"));
const BlackList = lazy(() => import("../../views/apps/blackList/list"));
const DemandList = lazy(() => import("../../views/apps/demand/list"));

const EmailSettingList = lazy(() =>
  import("../../views/apps/email/setting/list")
);
const EmailStaticList = lazy(() =>
  import("../../views/apps/email/static/list")
);
const EmailTempleteList = lazy(() =>
  import("../../views/apps/email/templete/list")
);

const CommissionsByRule = lazy(() =>
  import("../../views/apps/commissionsByRole/list")
);
const CommissionsByUser = lazy(() =>
  import("../../views/apps/commissionsByUser/list")
);
const Commissions = lazy(() => import("../../views/apps/commissions/list"));

const MyRefers = lazy(() => import("../../views/apps/myRefers/list"));
const FormCreate = lazy(() =>
  import("../../views/apps/usedconexForm/deliveryVideo")
);

const OrderConfirmationForm = lazy(() =>
  import("../../views/apps/orderConfirmationForm/list")
);

const InventoryFolderList = lazy(() =>
  import("../../views/apps/inventory/inventotyFolder/list")
);
const InventoryItemList = lazy(() =>
  import("../../views/apps/inventory/inventotyItem/list")
);
const InventoryItemView = lazy(() =>
  import("../../views/apps/inventory/inventotyItem/view")
);
const ContractViewUser = lazy(() =>
  import("../../views/apps/contract/contractViewUser")
);
const Contract = lazy(() =>
  import("../../views/apps/contract/view/ContractForm.js")
);

const ContractMaker = lazy(() =>
  import("../../views/apps/contract/contractMaker")
);
const Test = lazy(() => import("../../views/apps/contract/test"));

// const Templates = lazy(() =>
//   import("../../views/apps/contract/contractSelection")
// );
const ContractView = lazy(() =>
  import("../../views/apps/contract/contractView")
);

const ContractSeeLib = lazy(() =>
  import("../../views/apps/contract/contractSeeLib")
);
const W8BENForm = lazy(() =>
  import("../../views/apps/contract/W8BENForm/index.js")
);
const W9BENForm = lazy(() =>
  import("../../views/apps/contract/W9BENForm/index.js")
);
const EmailTemplate = lazy(() =>
  import("../../views/apps/emailTemplate/index.js")
);

const CreateTemplate = lazy(() =>
  import("../../views/apps/emailTemplate/components/CreateTemplate.js")
);
const Templates = lazy(() =>
  import("../../views/apps/mailMarketing/templates.js")
);

const AppRoutes = [
  {
    element: <InvoiceCreate />,
    path: "/apps/invoiceCreate",
    meta: {
      appLayout: true,
      className: "email-application",
    },
  },
  {
    element: <FormCreate />,
    path: "/apps/deliveryForm",
    meta: {
      appLayout: true,
      className: "email-application",
    },
  },
  {
    element: <OrderConfirmationForm />,
    path: "/apps/orderConfirmationForm",
  },
  {
    path: "/pages/welcome",
    element: <Welcome />,
    meta: {
      layout: "blank",
    },
  },
  {
    element: <VendorList />,
    path: "/apps/vendor/list",
  },
  {
    element: <DemandList />,
    path: "/apps/demand/list",
  },

  {
    element: <Contract />,
    path: "/apps/contract",
    meta: {
      action: "read",
      resource: "ACL",
      // menuHidden: true,
      layout: "blank",
      publicRoute: true,
    },
  },
  {
    element: <ContractViewUser />,
    path: "/apps/contractViewUser",
    meta: {
      action: "read",
      resource: "ACL",
      // menuHidden: true,
      layout: "blank",
      publicRoute: true,
    },
  },

  {
    element: <Templates />,
    path: "/apps/contractSelection",
  },

  {
    element: <ContractMaker />,
    path: "/apps/contractMakerPdf",
  },
  {
    element: <Test />,
    path: "/apps/test",
  },
  {
    element: <ContractView />,
    path: "/apps/contractView/:id",
  },

  {
    element: <ContractSeeLib />,
    path: "/apps/contractSeeLib",
  },
  {
    element: <W9BENForm />,
    path: "/apps/w9benform",
  },
  {
    element: <W8BENForm />,
    path: "/apps/w8benform",
  },
  {
    element: <BlackList />,
    path: "/apps/blackList/list",
  },
  {
    element: <LabelsList />,
    path: "/apps/labels/list",
  },
  {
    element: <TaxList />,
    path: "/apps/tax/list",
  },

  {
    element: <ReferralBounceList />,
    path: "/apps/referralBounce/list",
  },

  {
    element: <ReferralBounceAdmin />,
    path: "/apps/referralBounce/admin/list",
  },

  {
    element: <ReferralBounceCheck />,
    path: "/apps/referralBounce/check/list",
  },

  {
    element: <OrderList />,
    path: "/apps/order/list",
  },
  {
    element: <OrderSeasonalList />,
    path: "/apps/orderSeasonal/list",
  },
  {
    element: <EmailTemplate />,
    path: "/apps/emailTemplate",
  },

  {
    element: <CreateTemplate />,
    path: "/apps/CreateTemplate",
  },
  {
    element: <Templates />,
    path: "/apps/Templates",
  },

  {
    element: <SalesPiplineList />,
    path: "/apps/order/salesPipline/list",
  },

  {
    element: <OrderInvoice />,
    path: "/order/:id",
    meta: {
      action: "read",
      resource: "ACL",
      // menuHidden: true,
      layout: "blank",
      publicRoute: true,
    },
  },
  {
    element: <OrderPaymentDebit />,
    path: "/apps/order/paymentDebit/:id",
    meta: {
      action: "read",
      resource: "ACL",
      // menuHidden: true,
      layout: "blank",
      publicRoute: true,
    },
  },
  {
    element: <OrderPaymentECheck />,
    path: "/apps/order/paymentECheck/:id",
    meta: {
      action: "read",
      resource: "ACL",
      // menuHidden: true,
      layout: "blank",
      publicRoute: true,
    },
  },
  {
    path: "/apps/order/view",
    element: <Navigate to="/apps/order/view/1" />,
  },
  {
    element: <OrderView />,
    path: "/apps/order/view/:id",
  },

  {
    element: <StateList />,
    path: "/apps/state/list",
  },

  {
    element: <SaleManagerManagementList />,
    path: "/apps/saleManagerManagement/list",
  },

  {
    element: <DepotList />,
    path: "/apps/depot/list",
  },

  {
    element: <ContainerList />,
    path: "/apps/container/list",
  },

  {
    element: <Containers />,
    path: "/apps/container/containers",
  },

  {
    element: <EmailSettingList />,
    path: "/apps/email/setting/list",
  },

  {
    element: <EmailStaticList />,
    path: "/apps/email/static/list",
  },
  {
    element: <EmailTempleteList />,
    path: "/apps/email/templete/list",
  },

  {
    element: <DiscountOwnerList />,
    path: "/apps/discount/owner/list",
  },
  {
    element: <DiscountCustomList />,
    path: "/apps/discount/custom/list",
  },
  {
    element: <DiscountAgentList />,
    path: "/apps/discount/agent/list",
  },

  {
    element: <CommissionsByRule />,
    path: "/apps/commissionsByRole/list",
  },
  {
    element: <CommissionsByUser />,
    path: "/apps/CommissionsByUser/list",
  },
  {
    element: <MyRefers />,
    path: "/apps/MyRefers/list",
  },

  {
    element: <Commissions />,
    path: "/apps/commissions/list",
  },

  {
    element: <InventoryFolderList />,
    path: "/apps/inventoryFolder/list",
  },
  {
    element: <InventoryItemList />,
    path: "/apps/inventoryItem/list/:id",
  },
  {
    element: <InventoryItemView />,
    path: "/apps/inventoryItem/view/:id",
  },

  {
    element: <RankingAgentList />,
    path: "/apps/rankingAgent/list",
  },
  {
    element: <RankingManagerList />,
    path: "/apps/rankingManager/list",
  },
  {
    element: <RankingAssistantList />,
    path: "/apps/rankingAssistant/list",
  },
  {
    element: <RefundList />,
    path: "/apps/refund/list",
  },
  {
    element: <SumUpList />,
    path: "/apps/sumUp/list",
  },

  {
    element: <SumUpForAllList />,
    path: "/apps/sumUpForAll/list",
  },

  {
    path: "/apps/invoice/print/:id",
    element: <InvoicePrint />,
    meta: {
      action: "read",
      resource: "ACL",
      // menuHidden: true,
      layout: "blank",
      publicRoute: true,
    },
  },

  {
    element: <UserList />,
    path: "/apps/user/list",
  },
  {
    element: <AgentPageList />,
    path: "/apps/user/agentPage/list",
  },
  {
    element: <DriverList />,
    path: "/apps/user/driver/list",
  },
  {
    element: <AgentAssistantList />,
    path: "/apps/user/agentAssistant/list",
  },
  {
    element: <RecruiterUserList />,
    path: "/apps/user/recruiter/list",
  },
  {
    element: <ReferralUserList />,
    path: "/apps/user/referral/list/:id",
  },
  {
    element: <DeletedUserList />,
    path: "/apps/user/deleted/list",
  },
  {
    element: <InActiveAgentList />,
    path: "/apps/user/inActiveAgent/list",
  },
];

export default AppRoutes;
